// ********************************************************************************
// SWISSCOM CODE
// ********************************************************************************

import { legacyBootstrapDeferredSingleton } from 'bootstrap/load-terrific';

// Commons
import 'etc/designs/ecommerce/clientlibs/shared/js/common.js';

// Components
import 'etc/designs/ecommerce/clientlibs/desktop/js/abo.js';
import 'etc/designs/ecommerce/clientlibs/shared/js/clipping.js';

// Terrific modules
import 'etc/designs/ecommerce/clientlibs/shared/js/modules/Tc.Module.EcommerceProductDataHubTracking.js';
import 'etc/designs/ecommerce/clientlibs/shared/js/modules/Tc.Module.EcommerceProductDetail.js';
import 'etc/designs/ecommerce/clientlibs/shared/js/modules/Tc.Module.PricedBundleTitle.js';
import 'etc/designs/ecommerce/clientlibs/shared/js/modules/Tc.Module.ProductAmountPrice.js';
import 'etc/designs/ecommerce/clientlibs/shared/js/modules/Tc.Module.ProductImage.js';
import 'etc/designs/ecommerce/clientlibs/shared/js/modules/Tc.Module.ProductOptionsSummary.js';
import 'etc/designs/ecommerce/clientlibs/shared/js/modules/Tc.Module.ProductItemGroup.js';
import 'etc/designs/ecommerce/clientlibs/shared/js/modules/Tc.Module.ProductTeaser.js';
import 'etc/designs/ecommerce/clientlibs/shared/js/modules/Tc.Module.RetentionButton.js';
import 'etc/designs/ecommerce/clientlibs/shared/js/modules/Tc.Module.RetentionDisplay.js';
import 'etc/designs/ecommerce/clientlibs/shared/js/modules/Tc.Module.Subtotal.js';

import EcommerceProductDataHub from 'lib/ecommerce/Tc.Module.EcommerceProductDataHub';
import OnlineAvailabilityInfo from 'lib/ecommerce/Tc.Module.OnlineAvailabilityInfo';
legacyBootstrapDeferredSingleton({
	EcommerceProductDataHub,
	OnlineAvailabilityInfo,
});

// Must execute last
import 'etc/designs/ecommerce/clientlibs/shared/js/cbu.js';



// WEBPACK FOOTER //
// typescript://../clientlibs/js/by-category/scs.ecommerce.desktop.ts